// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "ts-loadable{display:block}ts-loadable.loading>*{opacity:.2}", "",{"version":3,"sources":["/Users/rlow/src/ctti/node_modules/ts-loadable/src/ts-loadable.scss"],"names":[],"mappings":"AAAA,YAEE,aAAA,CAEA,sBACE,UAAA","file":"ts-loadable.scss","sourcesContent":["ts-loadable {\n\n  display: block;\n\n  &.loading > * {\n    opacity: 0.2;\n  }\n\n}"]}]);
// Exports
module.exports = exports;
